import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'i2g-drawer',
  templateUrl: 'drawer.component.html',
  styleUrls: ['drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawerComponent implements OnInit {
  /**
   * To determine if tray is opened
   */
  @Input()
  set open(value: boolean) {
    this.show = value;
    this.openChange.emit(this.show);
  }

  /**
   * Parent must specify `position: relative` so drawer
   * can appear based on parent's position
   *
   * Parent also has to specify z-index bigger than drawer
   * to hide the drawer beneath
   */
  @Input() relativeToParent = false;

  /**
   * Drawer placement
   */
  @Input() placement: 'left' | 'right' = 'left';

  /**
   * Event emitted when the drawer open state is changed.
   * The name `openChange` is the convention that Angular uses for two-way binding
   * @see https://angular.io/guide/two-way-binding#how-two-way-binding-works
   */
  @Output() openChange = new EventEmitter<boolean>();

  show = false;

  constructor() {}

  ngOnInit() {}

  @HostListener('window:keyup', ['$event'])
  onWindowKeyup(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.show) {
      this.toggle();
    }
  }

  toggle() {
    this.show = !this.show;
    this.openChange.emit(this.show);
  }
}
